import { TranslationKeys } from '../../types/react-i18next';
import { HelpTabNavItem } from './types';

export const HELP_TAB_ENTITIES: ReadonlyArray<{
  value: HelpTabNavItem;
  path: TranslationKeys;
}> = [
  {
    value: HelpTabNavItem.ContactUs,
    path: 'help.paths.contactUs',
  },
  {
    value: HelpTabNavItem.Documentation,
    path: 'help.paths.documentation',
  },
] as const;
